import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router";

import type { DashboardConversationsDetailsQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_CONVERSATIONS_DETAILS_LOADER } from "@application/loaders/dashboard_conversation_details_loader";
import { DASHBOARD_CONVERSATIONS_LIST_LOADER } from "@application/loaders/dashboard_conversations_list_loader";

import { DASHBOARD_CONVERSATIONS_LINK } from "@application/navigation/dashboard_conversations_route";

import { Loader } from "@styled/loader";

const DashboardConversationsDetails = lazy(() =>
  import("./conversations_details").then((m) => ({
    default: m.DashboardConversationsDetails,
  })),
);
const DashboardConversationsList = lazy(() =>
  import("./conversations_list").then((m) => ({
    default: m.DashboardConversationsList,
  })),
);
const DashboardConversationsNew = lazy(() =>
  import("./conversations_new").then((m) => ({
    default: m.DashboardConversationsNew,
  })),
);

export const DASHBOARD_CONVERSATIONS_ROUTE = {
  path: "conversations",
  handle: DASHBOARD_CONVERSATIONS_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardConversationsList />
        </Suspense>
      ),
      loader: DASHBOARD_CONVERSATIONS_LIST_LOADER,
    },
    {
      path: "new",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardConversationsNew />
        </Suspense>
      ),
      handle: {
        name: "New",
        to: "/dashboard/conversations/new",
      },
    },
    {
      path: ":id",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardConversationsDetails />
        </Suspense>
      ),
      handle: (data: DashboardConversationsDetailsQuery): Breadcrumb => ({
        name: data.conversation.agent.name,
        to: `/dashboard/conversations/${data.conversation.id}`,
      }),
      loader: DASHBOARD_CONVERSATIONS_DETAILS_LOADER,
    },
  ],
} satisfies RouteObject;
